import { ArticleType } from '@wix/answers-api';

import { SupportType, SupportTypeArticle } from '../types';

const ARTICLE_TYPE_TO_SUPPORT_TYPE: Record<ArticleType, SupportTypeArticle> = {
  [ArticleType.ARTICLE]: SupportType.Article,
  [ArticleType.KNOWN_ISSUE]: SupportType.Article,
  [ArticleType.VIDEO]: SupportType.Article,
  [ArticleType.FEATURE_REQUEST]: SupportType.FeatureRequest,
} as const;

export const convertArticleType = (articleType: ArticleType): SupportTypeArticle => {
  return ARTICLE_TYPE_TO_SUPPORT_TYPE[articleType] || SupportType.Article;
};
